import * as React from 'react';
import { PupillaryDistanceDrawerLink } from './components/PupillaryDistanceDrawerLink/PupillaryDistanceDrawerLink.js';
import { PupillaryDistanceExternalLinkContainer } from './components/PupillaryDistanceExternalLink/PupillaryDistanceExternalLinkContainer.js';
import { usePupillaryDistanceDrawerLink } from './hooks/use-pupillary-distance-drawer-link.js';

const PupillaryDistanceLink = ({ className  })=>{
    const shouldUseDrawerLink = usePupillaryDistanceDrawerLink();
    if (shouldUseDrawerLink) {
        return /*#__PURE__*/ React.createElement(PupillaryDistanceDrawerLink, {
            className: className
        });
    }
    return /*#__PURE__*/ React.createElement(PupillaryDistanceExternalLinkContainer, {
        className: className
    });
};

export { PupillaryDistanceLink };
//# sourceMappingURL=PupillaryDistanceLink.js.map
